const TRANSLATIONS_EN = {
    connectionError: 'Connection error. Click to retry.',
    droneNameDuplicateError: 'A drone with this name already exists.',
    saveFailed: 'Save failed. Click to retry.'
};

export default TRANSLATIONS_EN;
